import { z } from 'zod';
import { ISTQBChapterRefSchema } from './ticket.schema';

export const SprintStatusSchema = z.enum(['locked', 'available', 'active', 'completed']);
export const BlockSchema = z.enum(['manual', 'technical', 'automation', 'graduation']);
export const ReleaseSchema = z.enum(['v0.5', 'v1.0', 'v1.5', 'v2.0']);

export const SprintSchema = z.object({
  id: z.string(),
  ord: z.number().int(),
  block: BlockSchema,
  title: z.string(),
  goal: z.string(),
  category: z.string(),
  estimateMin: z.number().int(),
  ticketIds: z.array(z.string()),
  finalTestBankId: z.string().optional(),
  istqb: z.array(ISTQBChapterRefSchema),
  aiEpisode: z
    .object({
      title: z.string(),
      summary: z.string(),
    })
    .optional(),
  release: ReleaseSchema.optional(),
  master: z.boolean().optional(),
  examSprint: z.boolean().optional(),
  /** Необязательный спринт (S06 · сертификация): не блокирует следующие спринты,
   *  не входит в прогресс курса, открывается вместе со следующим после предыдущего
   *  обязательного. Решение Genie 11 JUN 2026 (slot_s06_rework). */
  optional: z.boolean().optional(),
});

export type SprintStatus = z.infer<typeof SprintStatusSchema>;
export type Block = z.infer<typeof BlockSchema>;
export type Release = z.infer<typeof ReleaseSchema>;
export type Sprint = z.infer<typeof SprintSchema>;
